export const ENCODER_CONFIG_BASE = {
  // Based on https://api-ref.agora.io/en/video-sdk/web/4.x/globals.html#videoencoderconfigurationpreset
  bitrateMax: 3429,
  // Based on Agora recommended heuristics.
  bitrateMin: 857,
}

export const PORTRAIT_VIDEO_TRACK_CONFIG = {
  encoderConfig: {
    ...ENCODER_CONFIG_BASE,
    width: 720,
    height: 1280,
  },
}

export const LANDSCAPE_VIDEO_TRACK_CONFIG = {
  encoderConfig: {
    ...ENCODER_CONFIG_BASE,
    width: 1280,
    height: 720,
  },
}
